import React, { FC } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Box } from '@mui/material';
import { useQueryParams } from 'utils/useUriHelpers';
import { paths } from 'routing';
import { CampaignEditPage } from 'pages/CampaignPage/CampaignEditPage';

export const DuplicatePage: FC = () => {
  const { queryParams } = useQueryParams<{ brand: string | null }>({
    brand: null,
  });
  return (
    <Box mt={8}>
      <Switch>
        <Redirect
          exact
          from={paths.DUPLICATE_CAMPAIGN}
          to={{
            pathname: `${paths.DUPLICATE_CAMPAIGN}/generalities`,
            search: queryParams.brand ? `?brand=${queryParams.brand}` : '',
          }}
        />
        <Route path={paths.DUPLICATE_CAMPAIGN} component={CampaignEditPage} />
      </Switch>
    </Box>
  );
};
